export function HeaderSettingsContainer({ className = '', children }: React.PropsWithChildren<{ className?: string }>) {
    return <div className={'flex items-center' + className}>{children}</div>;
}
